import { useError } from 'error-provider/ErrorProvider';
import { GetUserAgentByIdQuery, useGetUserAgentByIdQuery } from 'graphql/generated';
import { useParams } from 'react-router-dom';

type AgentData = Extract<GetUserAgentByIdQuery['getUserAgentById'], { __typename?: 'AgentCreateType' }>['agent'];

type UserAgentData = {
    data: AgentData | null;
    loading: boolean;
};

export const useGetAgent = (): UserAgentData => {
    const params = useParams<{ id: string }>();
    const { showError } = useError();

    const { data, loading } = useGetUserAgentByIdQuery({
        variables: {
            agentId: Number(params.id),
        },
        onError(error) {
            showError(undefined, error);
        },
    });

    const agentData = data?.getUserAgentById.__typename === 'AgentCreateType' ? data.getUserAgentById.agent : null;

    return { data: agentData, loading };
};
